var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "andon-bg",
      style: {
        "background-image": "url(" + (_vm.data && _vm.data.imageUrl) + ")"
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _vm._v("\n            " + _vm._s(_vm.data.title) + "\n        ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col andon-box" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "row andon-content" }, [
            _c("span", { staticClass: "w-100" }, [
              _vm._v(_vm._s(_vm.data.target))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row andon-footer" }, [
            _c("span", { staticClass: "w-100" }, [
              _vm._v(_vm._s(_vm.data.targetDescription))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col andon-box" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "row andon-content" }, [
            _c("span", { staticClass: "w-100" }, [
              _vm._v(_vm._s(_vm.data.actual))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row andon-footer" }, [
            _c("span", { staticClass: "w-100" }, [
              _vm._v(_vm._s(_vm.data.actualDescription))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col andon-box" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "row andon-content" }, [
            _c("span", { staticClass: "w-100" }, [
              _vm._v(_vm._s(_vm.data.previous))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row andon-footer" }, [
            _c("span", { staticClass: "w-100" }, [
              _vm._v(_vm._s(_vm.data.previousDescription))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.formatDate(_vm.lastUpdate) || "Loading ...") +
              "\n            "
          ),
          _c("span", { staticClass: "float-right" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.formatTime(_vm.lastUpdate) || "Loading ...") +
                "\n            "
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "row andon-title",
        staticStyle: { "background-color": "black" }
      },
      [_c("span", { staticClass: "w-100" }, [_vm._v("Target")])]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "row andon-title",
        staticStyle: { "background-color": "#7030a0" }
      },
      [_c("span", { staticClass: "w-100" }, [_vm._v("Actual")])]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "row andon-title",
        staticStyle: { "background-color": "#00b050" }
      },
      [_c("span", { staticClass: "w-100" }, [_vm._v("Previous")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }